<!-- ── Car header ─────────────────────────────────────────────── -->
<div class="car-header">

    <div class="car-header__top">
        <button class="back-btn" (click)="goBack()">
            <img src="assets/icons/arrow.svg" alt="Back arrow" style="transform: rotate(180deg);" />
            Back
        </button>


        <div class="header-actions">
            <p-button label="Edit" severity="primary" size="small" (onClick)="updateCarDialog = true">
                <ng-template #icon><img src="assets/icons/edit-white.svg" alt="edit"
                        (error)="$any($event.target).style.display='none'" /></ng-template>
            </p-button>
        </div>
    </div>

    @if (car(); as c) {
    <div class="car-header__info">
        <div class="car-header__title-row">
            <h2 class="car-plate">{{ c.plateNo }}</h2>
            <span class="status-badge" [style.background]="getStatusStyle(c.status).background"
                [style.color]="getStatusStyle(c.status).color">
                <span class="status-dot" [style.background]="getStatusStyle(c.status).color"></span>
                {{ c.status.split('_').join(' ') | titlecase }}
            </span>
        </div>
        <p class="car-model">{{ c.model.maker }} {{ c.model.name }} · {{ c.model.bodyType }}</p>
        <p class="car-meta">
            <span>VIN: {{ c.vin }}</span>
            <span>ID: #{{ carID }}</span>
        </p>
    </div>
    } @else {
    <div class="car-header__info">
        <h2 class="car-plate">ID: #{{ carID }}</h2>
    </div>
    }

</div>
@if (car(); as c) {

    <!-- ── Tabs ───────────────────────────────────────────────────── -->
    <p-tabs [(value)]="activeTab" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab value="0">General Info</p-tab>
            <p-tab value="1">Activity</p-tab>
            <p-tab value="2">Notes</p-tab>
            <p-tab value="3">Commands</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel value="0">
                <app-car-details-general-info-component [carDetails]="car()!" />
            </p-tabpanel>
            <p-tabpanel value="1">
                <app-car-details-activity-component [carID]="carID" />
            </p-tabpanel>
            <p-tabpanel value="2">
                <app-car-details-notes [carID]="carID" />
            </p-tabpanel>
            <p-tabpanel value="3">
                <app-car-details-commands-component [carID]="carID" />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>

    @defer (when addCarNoteDialog; prefetch on idle) {
    <app-add-car-note-form (addedCarNote)="onCarNoteAdded()" [selectedCarID]="carID" [(visibility)]="addCarNoteDialog" />
    }

    @defer (when updateCarDialog; prefetch on idle) {
    <app-update-car-form (updatedCar)="onCarUpdated()" [selectedCar]="car()!" [(visibility)]="updateCarDialog" />
    }

}